import { render, staticRenderFns } from "./FcUserAvatar.vue?vue&type=template&id=5f692522"
import script from "./FcUserAvatar.vue?vue&type=script&lang=js"
export * from "./FcUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports